// @jsx createElement
import createElement from './createElement'; // eslint-disable-line no-unused-vars

function insertChildern(children, name) {
	if (!children) return null;

	if (children && !name) return children;

	const slotted = [];
	const {length: childrenCount} = children;
	for (let i = 0; i < childrenCount; i++) {
		const child = children[i];
		if (name === (child.data && child.data.props && child.data.props.slot)) slotted.push(child);
	}

	return slotted;
}

/**
 * Creates a slot using snabbdom
 * @method createSlot
 * @param children
 * @param name
 * @returns {*}
 */
export default function createSlot(children, name) {
	return <slot name={name}>{insertChildern(children, name)}</slot>;
}
